import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { BooleanToggle } from '../controls/boolean-toggle';
import type { SectionProps } from './types';

export const FormSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <BooleanToggle
      label={t['com.streamlain.customApps.viewConfig.form.label']()}
      description={t['com.streamlain.customApps.viewConfig.form.desc']()}
      data-sl-field="form"
      value={row.form}
      onChange={v => setField('form', v)}
    />
  );
};
